module.exports = __webpack_public_path__ + "img/39.9ec8aca8.jpg";